import React, { useEffect, useState } from "react";
import { useIndexedDBContext } from "./indexed-db-provider";

interface ThemeProviderProps {
    children: React.ReactNode;
}

export const ThemeProvider: React.FC<ThemeProviderProps> = ({ children }) => {
    const { userSettingsDb } = useIndexedDBContext();
    const [isInitialized, setIsInitialized] = useState(false);

    useEffect(() => {
        const loadTheme = async () => {
            try {
                const settings = await userSettingsDb.getAllItems();
                const theme = settings[0]?.theme || "light";
                document.documentElement.classList.toggle("dark", theme === "dark");
                setIsInitialized(true);
            } catch (error) {
                
            }
        };

        loadTheme();
    }, [userSettingsDb]);

    if (!isInitialized) {
        return (
            <div className="flex items-center justify-center min-h-screen bg-gray-100">
                <div className="p-6 bg-white rounded-lg shadow-md">
                    <div className="flex items-center space-x-3">
                        <div className="w-6 h-6 border-2 border-blue-500 border-t-transparent rounded-full animate-spin"></div>
                        <p className="text-gray-700">loading-databases</p>
                    </div>
                </div>
            </div>
        );
    }

    return <>{children}</>;
};
